export type RestaurantRole =
  | 'OWNER'
  | 'ADMIN'
  | 'ATTENDANT'
  | 'CASHIER';

export type Permission =
  | 'DASHBOARD_VIEW'
  | 'ORDERS_VIEW'
  | 'PRODUCTS_VIEW'
  | 'PRODUCTS_MANAGE'
  | 'RESTAURANTS_VIEW'
  | 'RESTAURANTS_MANAGE'
  | 'CASH_FLOW_VIEW'
  | 'CASH_FLOW_MANAGE'
  | 'SETTINGS_VIEW'
  | 'SETTINGS_MANAGE'
  | 'TEAM_VIEW'
  | 'TEAM_MANAGE';

export const ROLE_PERMISSIONS: Record<
  RestaurantRole,
  Permission[]
> = {
  OWNER: [
    'DASHBOARD_VIEW',

    'ORDERS_VIEW',

    'PRODUCTS_VIEW',
    'PRODUCTS_MANAGE',

    'RESTAURANTS_VIEW',
    'RESTAURANTS_MANAGE',

    'CASH_FLOW_VIEW',
    'CASH_FLOW_MANAGE',

    'SETTINGS_VIEW',
    'SETTINGS_MANAGE',

    'TEAM_VIEW',
    'TEAM_MANAGE'
  ],

  ADMIN: [
    'DASHBOARD_VIEW',

    'ORDERS_VIEW',

    'PRODUCTS_VIEW',
    'PRODUCTS_MANAGE',

    'RESTAURANTS_VIEW',
    'RESTAURANTS_MANAGE',

    'CASH_FLOW_VIEW',
    'CASH_FLOW_MANAGE',

    'SETTINGS_VIEW',
    'SETTINGS_MANAGE',

    'TEAM_VIEW',
    'TEAM_MANAGE'
  ],

  ATTENDANT: [
    'DASHBOARD_VIEW',
    'ORDERS_VIEW',
    'PRODUCTS_VIEW'
  ],

  CASHIER: [
    'DASHBOARD_VIEW',
    'ORDERS_VIEW',
    'CASH_FLOW_VIEW'
  ]
};